export interface Lead {
  firstName: string;
  lastName?: string;
  company?: string;
  phoneNumber;
  email: string;
  seats?: number;
  referralCode?;
  medium: string;
  source: string;
  customMedium?: string;
  customSource?: string;
  info?: string;
  country?: string;
}

export const SOURCES = [
  'phone',
  'social',
  'blog',
  'website',
  'email',
  'organic',
  'referral',
  'other'
]

export const MEDIUMS = [
  'facebook-ads',
  'facebook-post',
  'facebook-message',
  'google-ads',
  'chat',
  'newsletter',
  'other'
]
